import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

const CardImage = ({ card, width = 120, height = 76, sx = {} }) => {
  const [error, setError] = useState(false);
  const url = card.image_url;
  const isValidImg = url && !url.includes('.html') && !error;

  if (isValidImg) {
    return (
      <Box
        component="img"
        src={url}
        alt={card.name}
        loading="lazy"
        onError={() => setError(true)}
        sx={{
          width,
          height,
          objectFit: 'contain',
          borderRadius: '8px',
          ...sx,
        }}
      />
    );
  }

  const initials = (card.bank || 'CC')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 3)
    .toUpperCase();

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: '8px',
        bgcolor: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: '1.2rem', letterSpacing: 1 }}>
        {initials}
      </Typography>
    </Box>
  );
};

export default CardImage;
